import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-bold-document-upload',
  imports: [],
  templateUrl: './icon-bold-document-upload.component.html',
})
export class IconBoldDocumentUploadComponent {
  @Input() color: string = 'currentColor';
  @Input() size: string = '24';
}
